<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">本SA相違一覧</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search">検索</v-btn>
        <v-btn @click="confirmSa" v-permit.SHARP_PSCS_CONFIRM
          >変更・取消データ確認</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="海外取引先"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field label="BL NO" v-model="query.blNo"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                label="INV NO"
                v-model="query.invoiceNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.masterBlNo }}</td>
          <td>{{ props.item.houseBlNo }}</td>
          <td>{{ props.item.blIssueDate }}</td>
          <td>{{ invoiceNo(props.item) }}</td>
          <!-- <td>{{ props.item.comparisonResult }}</td> -->
          <td>{{ props.item.handleStatus }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      results: [],
      selected: [],
      query: {},
      loading: false,
      headers: [
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'Master B/L No', value: 'masterBlNo', sortable: false },
        { text: 'House B/L No', value: 'houseBlNo', sortable: false },
        { text: 'B/L Date', value: 'blIssueDate', sortable: false },
        { text: 'INV No', value: 'invoiceNo', sortable: false },
        // { text: '本SA比較結果', value: 'comparisonResult', sortable: false },
        { text: '処理Status', value: 'status', sortable: false },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    }
  },
  methods: {
    invoiceNo(item) {
      return (
        item.packages.find((p) => p.invoiceNo != null) &&
        item.packages.find((p) => p.invoiceNo != null).invoiceNo
      )
    },
    search() {
      // this.pagination.page = 0
      this.autoload = true
      this.$storeParams()
      this.load()
    },
    load() {
      this.$http.get('/conflict-sa').then((res) => {
        this.results = res.data
      })
    },
    confirmSa() {
      this.$router.push({
        path: '/B1901',
        query: {
          id: this.selected[0].id,
          status: this.selected[0].handleStatus,
          type: 'BOTH',
        },
      })
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.search()
    },
  },
  mounted() {
    this.$loadParams()
  },
}
</script>
